import React from 'react';
import { Box } from 'theme-ui';
import GoogleMapReact from 'google-map-react';

function Marker(props) {
  const { hovering, $hover, icon } = props;
  return (
    <Box
      sx={{
        transition: 'all 0.2s ease-in-out',
        transform: $hover || hovering ? 'scale(1.4)' : 'none',
        height: '1.5rem',
        width: '1.5rem',
        position: 'relative',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      {...props}
    >
      <Box
        as="img"
        sx={{
          width: '2rem',
          height: '2rem',
          transform: 'translateZ(0) translate(-50%, -100%)',
        }}
        src={icon?.image?.url}
      />
    </Box>
  );
}

const Map = ({ zoom, center, children }) => {
  return (
    <Box sx={{ height: '100%', width: '100%' }}>
      <GoogleMapReact
        yesIWantToUseGoogleMapApiInternals
        bootstrapURLKeys={{ key: 'AIzaSyB1Y89jppm1wcjznU70trVruoI13Q8O6Hc' }}
        defaultCenter={center}
        defaultZoom={zoom}
      >
        {children}
      </GoogleMapReact>
    </Box>
  );
};

export default Map;
export { Marker };
